package org.teddapp.project.core

// Le noyau Rust n'est pas encore compilé pour le navigateur : l'application s'en passe,
// comme partout où la bibliothèque native manque.
actual fun openTeddCore(dir: String, deviceId: String): TeddCoreBridge? = null
